var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank-list"},_vm._l((_vm.banks),function(bank){return _c('div',{key:bank.id,staticClass:"bank-item",on:{"click":function($event){return _vm.handleBankClick(bank)}}},[_c('div',{staticClass:"bank-icon",style:({ background: bank.color })},[_c('a-icon',{attrs:{"type":bank.icon}})],1),_c('span',[_vm._v(_vm._s(bank.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }